import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=234f6f98&scoped=true&"
import script from "./DetailOrder.vue?vue&type=script&lang=js&"
export * from "./DetailOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrder.vue?vue&type=style&index=0&id=234f6f98&scoped=true&lang=css&"
import style1 from "./DetailOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f6f98",
  null
  
)

export default component.exports